<template>
<div>
    <div class="w-100"> <img src="@/assets/imagenes/micrositioPlaneacion/planeacion-microsite-header.jpg" class="w-100" alt=""> </div>
    <div class="container mt-5">
        <div class="row d-flex justify-content-between">
            <router-link class="col-sm-12 col-md-2 border py-3 m-3 card-planeacion" :to="{name: 'loginRegistro'}">
                <img src="@/assets/imagenes/micrositioPlaneacion/SVG/Buscador-de-Formatos-para-Servidores.svg" alt="">
                <p class="title my-0">Buscador de Formatos</p>
                <p>Buscador de Formatos para Servidores Públicos de la Secretaria de Hacienda.</p>
            </router-link>
            <div class="col-sm-12 col-md-2 border py-3 m-3 card-planeacion">
                <img src="@/assets/imagenes/micrositioPlaneacion/SVG/Sistema-Administrador-de-Formatos.svg" alt="">
                <p class="title">Sistema Administrador de Formatos SAF</p>
                <ul>
                    <li><a class="text-muted" target="_blank" href="http://172.31.9.3/SAF/">Intranet</a></li>
                    <li><a class="text-muted" target="_blank" href="http://presupuesto.haciendachiapas.gob.mx/SAF/">Internet</a></li>
                </ul>
            </div>
            <router-link class="col-sm-12 col-md-2 border py-3 m-3 card-planeacion" :to="{name: 'manual-de-formatos'}">
                <img src="@/assets/imagenes/micrositioPlaneacion/SVG/Manual-de-Formatos.svg" alt="">
                <p class="title mb-0">Manual de Formatos</p>
                <p class="my-0">Documento rector que estandariza los formatos oficiales e instructivos de llenado de la Secretaría de Hacienda</p>
            </router-link>
            <router-link class="col-sm-12 col-md-2 border py-3 m-3 card-planeacion" :to="{name: 'TramitesHaciendaExternos'}">
                <img src="@/assets/imagenes/micrositioPlaneacion/SVG/Enlaces-de-Interes.svg" alt="">
                <p class="title mb-0">Enlaces de Interés</p>
                <p class="my-0">Buscador de Formatos de la Secretaría de Hacienda</p>
            </router-link>
            <router-link class="col-sm-12 col-md-2 border py-3 m-3 card-planeacion" :to="{name: 'curso-de-Capacitacion'}">
                <img src="@/assets/imagenes/micrositioPlaneacion/SVG/Curso-de-Capacitacion-del-Sistema-.svg" class="change-my-color" alt="">
                <p class="title my-0">Curso de Capacitación</p>
                <p>Curso de Capacitación del Sistema Administrador de Formatos</p>
            </router-link>
            <div class="col-12 py-3 mt-5 text-center" style="color: #8b8989;">
                <p style="font-size:1.1rem; margin-bottom:0;">Contacto</p>
                <p style="margin-top:0;">Número de contacto: 961-691-4043, a las extensiones 65532 y 65300. <br>
                Oficinas: Área de Sistemas de Calidad de la Unidad de Planeación, ubicada en el Edificio Torre Chiapas, 4º piso, Col. El Retiro, Tuxtla Gutiérrez, Chiapas <br>
                Email: control.formatos@haciendachiapas.gob.mx
                </p>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
}
</script>

<style scoped>

    .card-planeacion{
        border-radius: 3px;
        border-bottom: 3px solid #bc955b !important;
        text-align: center;
        box-shadow: 0px 2px 5px #c8c8c8;
        
    }
    .card-planeacion:hover{ box-shadow: 1px 10px 5px 0px rgba(199,199,199,1); }
    img{ width: 5.5rem; }
    .card-planeacion p {
        color: #8b8989;
        font-size: .87rem;
    }
    .card-planeacion ul{ 
        padding: 0;
        list-style: none;
     }
    .card-planeacion ul li a:link {
        text-decoration: underline;
    }

    .title{
        font-weight: 500 !important;
        color:black !important;
        font-size: .9rem !important;
    }

    a:hover { text-decoration: none; }
    
</style>